import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "dealshed_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-4" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto bg-white border border-slate-200 shadow-lg rounded-xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <span className="grid place-items-center w-10 h-10 rounded-full bg-emerald-100 text-emerald-700 shrink-0"><Cookie size={20} /></span>
        <p className="text-sm text-slate-600 flex-1">
          We use cookies to keep you logged in and to understand how DealShed is used. Essential cookies are always on. Read our{" "}
          <Link to="/cookies" className="text-emerald-600 font-medium hover:underline" data-testid="cookie-policy-link">Cookie Policy</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" onClick={() => decide("essential")} data-testid="cookie-reject" className="flex-1 sm:flex-none">Essential only</Button>
          <Button onClick={() => decide("all")} data-testid="cookie-accept" className="flex-1 sm:flex-none bg-emerald-600 hover:bg-emerald-700 text-white">Accept all</Button>
        </div>
      </div>
    </div>
  );
}
